import { AppLayout } from "@/components/app-layout/AppLayout";
import { AppSidebar } from "@/components/app-layout/AppSidebar";
import { SidebarContentAdmin } from "@/components/app-layout/menus/SidebarContentSettings";
import {
  faBuildings,
  faIndustry,
  faTasks,
  faUsers,
} from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import { Outlet } from "@tanstack/react-router";

export const GlobalAdminLayout = () => {
  return (
    <>
      <AppLayout fixedSidebar>
        <AppSidebar.ContentPortal>
          <SidebarContentAdmin
            title="Super Admin"
            settings={[
              {
                name: "Organizations",
                link: { to: "/admin/organizations" as const },
                icon: faBuildings,
              },
              {
                name: "Groups",
                link: { to: "/admin/groups" as const },
                icon: faIndustry,
              },
              {
                name: "Users",
                link: { to: "/admin/users" as const },
                icon: faUsers,
              },
              {
                name: "Tasks",
                link: { to: "/admin/tasks" as const },
                icon: faTasks,
              },
            ]}
          />
        </AppSidebar.ContentPortal>
        <Outlet />
      </AppLayout>
    </>
  );
};
